<!-- eslint-disable -->
<template>

    <div>

        <b-alert
                show
                variant="light"
                class="alert alert-custom alert-white alert-shadow fade show gutter-b"
        >
            <div class="alert-icon">
            <span class="svg-icon svg-icon-lg">
              <inline-svg src="media/svg/icons/Tools/Compass.svg" />
            </span>
            </div>
            <div class="alert-text">
                Атрибуты позволяют определять дополнительные сведения о товаре, такие как размер и цвет и тд. Эти атрибуты можно использовать в фильтре магазина
            </div>
        </b-alert>
        <!--end::Notice-->

        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Атрибуты</h3>
                        <div class="card-toolbar">
                            <b-button @click="addAttribute" variant="primary">Создать атрибуты</b-button>
                        </div>
                    </div>
                    <div class="card-body">

                        <div v-if="attributes.length === 0" class="text-center mb-10">
                            Атрибуты не найдены! <a href="#" @click="addAttribute">Создать атрибут</a>
                        </div>

                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                                <!--begin::Table-->
                                <div v-else class="table-responsive mt-3">
                                    <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
                                        <thead>
                                        <tr class="text-left">
                                            <th class="pl-0">Название</th>
                                            <th>Значения</th>
                                            <th class="pr-0 text-right">Действия</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <template v-for="attribute in attributes">
                                            <tr>
                                                <td class="pl-0">
                                                    <div class="d-flex align-items-center">
                                                        <router-link :to="{ name: 'EditAttribute', params: {id: attribute.id}}"
                                                                     class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                            {{attribute.name}}
                                                        </router-link>
                                                    </div>
                                                </td>
                                                <td>

                                                    <span class="text-muted font-weight-bold">
                                                        <template v-for="option in attribute.options">
                                                       {{option.name}},
                                                        </template>
                                                    </span>
                                                </td>

                                                <td class="pr-0 text-right">
                                                    <router-link :to="{ name: 'EditAttribute', params: {id: attribute.id}}" v-b-tooltip.hover title="Редактировать атрибут" class="btn btn-icon btn-light btn-hover-primary btn-sm"><i class="fas fa-edit"></i></router-link>
                                                    <b-link @click="showModal(attribute.name,  attribute.id)" v-b-tooltip.hover title="Удалить атрибут" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-alt"></i></b-link>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                                <!--end::Table-->

                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить атрибут: {{modalAttribute.title}}?</h3>

                <div role="alert" class="alert alert-warning alert-dismissible text-dark text-center">
                    <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                    <br>При удаление атрибута вы удаляете его из всех товаров.
                    <br>Убедитесь в отсутствии вариации с этим атрибутом
                </div>

            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideModal">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button ref="delete_attribute" class="mt-3" variant="outline-danger" block @click="deleteAttribute(modalAttribute.id)">Удалить</b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal ref="delete-attribute-fail" centered hide-footer title="Сообщение">
            <div class="d-block text-center">
                <h3>Невозможно удалить атрибут</h3>

                <div role="alert" class="alert alert-danger alert-dismissible text-white">
                    <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                    <br>Имеются вариации с этим атрибутом в следующих товарах:
                </div>



                <div class="table-responsive mt-2 mb-2">
                    <table class="table table-head-custom table-vertical-center">
                        <thead>
                        <tr class="text-left">
                            <th class="pl-0">Заголовок</th>
                            <th class="pr-0 text-right">Действия</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="product in productsAttribute">
                            <td class="pl-0">
                                <div class="d-flex align-items-center">
                                    <div class="symbol symbol-50 flex-shrink-0 mr-4">
                                        <div class="symbol-label"
                                             :style="{ backgroundImage: 'url(' + $urlBackEnd(product.images[0].thumbnail) + ')' }">
                                        </div>
                                    </div>

                                    <div>
                                        <router-link :to="{ name: 'EditProduct', params: {id: product.id}}" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{product.title}}</router-link>
                                        <span class="text-muted font-weight-bold d-block"> {{product.stock}} шт.</span>
                                    </div>
                                </div>
                            </td>
                            <td class="pr-0 text-right">
                                <router-link :to="{ name: 'EditProduct', params: {id: product.id}}" v-b-tooltip.hover title="Редактировать товар" class="btn btn-icon btn-light btn-hover-primary btn-sm"><i class="fas fa-edit"></i></router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <small>Показано не более 20 товаров</small>

            </div>

            <b-button class="mt-3" variant="primary" block @click="hideModalDelAttributeFail">Закрыть</b-button>

        </b-modal>

    </div>
</template>

<script>


    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {SET_ALERT} from "@/core/services/store/alert.module";
    import {
        DELETE_ATTRIBUTE,
        GET_ATTRIBUTES,
    } from "@/core/services/store/attributes.module";

    export default {
        name: "Attributes",

        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Атрибуты товаров" }]);
            this.$store.dispatch(GET_ATTRIBUTES);
        },

        computed: {
            ...mapGetters({
                attributes: 'gettersAttributes',
                load: 'getAttributeLoad',
            }),
        },

        data(){
            return{
                productsAttribute: [],
                modalAttribute: {},
                selected: [],
                actions: null
            }
        },

        methods:{
            addAttribute(){
                this.$router.push({ name: "AddAttribute" })
            },


            deleteAttribute(id){

                const submitButton = this.$refs["delete_attribute"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(DELETE_ATTRIBUTE, id)
                    .then(() => {
                        this.showAlert('Атрибут успешно удален', 'success', 'toast');
                        this.$store.dispatch(GET_ATTRIBUTES);
                    })
                    .catch((response) => {
                        if (response.status === 403 && response.data.products.length > 0){
                            this.showAlert('Невозможно удалить. Имеются вариации с данным атрибутом', 'danger', 'toast');
                            this.productsAttribute = response.data.products;
                            this.$refs['delete-attribute-fail'].show()
                        } else {
                            this.showAlert('Ошибка удаления. Код ошибки: ' + response.status, 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        this.hideModal()
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    })
            },


            hideModalDelAttributeFail(){
                this.$refs['delete-attribute-fail'].hide()
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            showModal(title, id) {
                this.modalAttribute = {
                    'title': title,
                    'id': id
                };
                this.$refs['delete-modal'].show()
            },

            hideModal() {
                this.modalAttribute = {};
                this.$refs['delete-modal'].hide()
            }
        },


    }
</script>

<style scoped>

</style>